import { render, staticRenderFns } from "./EditBase.vue?vue&type=template&id=8ee62734&"
import script from "./EditBase.vue?vue&type=script&lang=js&"
export * from "./EditBase.vue?vue&type=script&lang=js&"
import style0 from "./EditBase.vue?vue&type=style&index=0&id=8ee62734&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports